import { IAuthResponseData, IToken } from '../../store/user/user.interface';

//Сохранить токен
export const saveTokensStorage = (token: string) => {
  localStorage.setItem('st', token);
};
//Удалить токен
export const removeTokensStorage = () => {
  localStorage.removeItem('st');
};
